import React, { useEffect, useRef } from "react";

import "./loader.css";

const ERROR_TIMEOUT = 7000;

export default function Loader() {

  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    timeoutId.current = setTimeout(() => {
      //window.open("/error/1", "_self");
    }, ERROR_TIMEOUT);
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  })

    return <div className="loader-wrapper">
  <div className="loader">
    <div className="bar"></div>
  </div>
</div>;
}